/**
 * Whitespace cleaner — pure, deterministic whitespace normalization.
 * Safe to render server-side.
 */

export interface CleanOptions {
  /** Trim leading/trailing whitespace from each line. */
  trimLines?: boolean;
  /** Collapse runs of spaces/tabs within a line to a single space. */
  collapseSpaces?: boolean;
  /** Drop blank/whitespace-only lines. */
  removeBlankLines?: boolean;
  /** Trim the whole result at the end. */
  trimResult?: boolean;
}

export interface CleanResult {
  text: string;
  /** Character length before cleaning. */
  before: number;
  /** Character length after cleaning. */
  after: number;
}

export function cleanWhitespace(
  text: string,
  opts: CleanOptions = {},
): CleanResult {
  const before = text.length;

  let lines = text.split("\n").map((line) => {
    let l = line;
    if (opts.collapseSpaces) l = l.replace(/[ \t]+/g, " ");
    if (opts.trimLines) l = l.trim();
    return l;
  });

  if (opts.removeBlankLines) {
    lines = lines.filter((l) => l.trim() !== "");
  }

  let result = lines.join("\n");
  if (opts.trimResult) result = result.trim();

  return { text: result, before, after: result.length };
}
